<template>
    <div class="homeCarousel">
        <el-carousel :height="bannerHeight + 'px'">
            <el-carousel-item v-for="(item,index) in carouselData" :key="index">
                <img :src="item" alt="" class="homeCarouselImg">
            </el-carousel-item>
        </el-carousel>
    </div>
</template>

<script>
export default {
    name: "carousel",
    data() {
        return {
            // 图片父容器高度
            bannerHeight :1000,
            // 浏览器宽度
            screenWidth :0,

            carouselData:[require('@/assets/home/topbanner/banner1.png'),require('@/assets/home/topbanner/banner2.png'),require('@/assets/home/topbanner/banner3.png'),require('@/assets/home/topbanner/banner4.png'),require('@/assets/home/topbanner/banner5.png')],
        }
    },
    methods:{
        setSize:function () {
            // 通过浏览器宽度(图片宽度)计算高度
            this.bannerHeight = 519 / 1920 * this.screenWidth;
        },
    },
    mounted(){
        //初始化动画
        this.$nextTick(()=>{
            this.$wow.init()
        })

        // 首次加载时,需要调用一次
        this.screenWidth =  window.innerWidth;
        this.setSize();
        // 窗口大小发生改变时,调用一次
        window.onresize = () =>{
            this.screenWidth =  window.innerWidth;
            this.setSize();
        }
    }
}
</script>

<style lang="scss">
    :root {
        --web-max-width: 1920px;
        --web-min-width: 1300px;
    }
    .homeCarousel{
      .el-carousel__container{
        //min-width:var(--web-min-width);
        // max-width:var(--web-max-width);
        //  height: 746px;
        //margin:0 auto;
          //height: 480px;

      }
      .homeCarouselImg{

        //height: 100%;
        //min-height: 570px;
        // width: auto;
        cursor: pointer;

          /*设置图片宽度和浏览器宽度一致*/
          width: 100%;
          height: inherit;

      }
    }

</style>
